export default function formatCurrency(value:any, locale:any, currency:any) {
    if (value) {
        return value.toLocaleString(locale, {
            style: "currency",
            currency: currency,
        });
    }
}